// --- React
import { useCallback } from "react";
// --- Redux
import { useDispatch } from "react-redux";

/**
 * useLoading Hook
 *
 * This hook provides functions to manage the loading state in the Redux store.
 * It allows components to show or hide a loading spinner.
 *
 * @hook
 * @returns {Object} An object containing functions to set the loading state.
 **/
export function useLoading() {
  const dispatch = useDispatch();

  const setLoadingTrue = useCallback(() => {
    dispatch({ type: "SHOW_SPINNER", showSpinner: true });
  }, [dispatch]);

  const setLoadingFalse = useCallback(() => {
    dispatch({ type: "SHOW_SPINNER", showSpinner: false });
  }, [dispatch]);

  return { setLoadingTrue, setLoadingFalse };
}
